import { DateRange, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import { useMemo } from 'react';

import { AbsenceGridRow } from '../UserProfileAbsenceGridForm/UserProfileAbsenceGridForm.types';

import { DateRangePickerCellStyled } from './DateRangePickerCell.styled';

interface DateRangePickerCellProps {
  row: AbsenceGridRow;
  field: string;
}

export interface DateRangePickerChangeEvent extends DateRangePickerCellProps {
  value: DateRange<Date>;
}

interface DateRangePicker {
  from?: Date;
  to?: Date;
}
interface DateRangePickerValueProps {
  value?: DateRangePicker;
  onValueChange?: ({ row, field, value }: DateRangePickerChangeEvent) => void;
}

export const DateRangePickerCell = ({
  onValueChange,
  row,
  field,
  value,
}: DateRangePickerCellProps & DateRangePickerValueProps) => {
  const memorizedValue = useMemo<DateRange<Date>>(() => [value?.from ?? null, value?.to ?? null], [value]);

  return (
    <DateRangePickerCellStyled
      calendars={1}
      disablePast
      slots={{ field: SingleInputDateRangeField }}
      value={memorizedValue}
      onChange={(value) => onValueChange?.({ row, field, value })}
    />
  );
};
